// extracted by mini-css-extract-plugin
export default {"aboutPage":"About_aboutPage__rYP7z","disclaimer":"About_disclaimer__IThlt","small":"About_small__WsZae","paragraphs":"About_paragraphs__I62Qn"};